import React from "react";

const OkuProfile = () => {
  return (
    <div className=" dark:bg-gradient-to-r from-black to-stone-700 bg-white grid items-center justify-center p-6">
      <span id="pro"></span>
      <div className="max-w-4xl w-full rounded-lg overflow-hidden">
        <div className="p-8">
        <div className="flex justify-center mb-6">
            {/* <img
              className="h-96 w-96 rounded-full mx-auto"
              src={"https://firebasestorage.googleapis.com/v0/b/markers-digital-pro.appspot.com/o/profileImages%2FibCmRLP8Ona3TyVZtUK1qA8uax72?alt=media&token=75cabaa9-d0e3-43c2-8da2-0d0d76059ed0"}
              alt="Profile Picture"
            /> */}
          </div>
                    <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">Professional Summary</h2>
            <p className="text-gray-700 dark:text-white">
              Experienced Full-Stack Engineer with over 9 years of expertise in developing
              secure, scalable, and user-focused applications across web2 and web3 ecosystems.
              Passionate about bridging the gap between the physical and digital worlds using
              cutting-edge blockchain, NFC, and software technologies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">Key Skills</h2>
            <ul className="list-disc list-inside text-gray-700 dark:text-white">
              <li>Languages/Frameworks: JavaScript, TypeScript, Node.js, Nest.js, React, Next.js, Solidity</li>
              <li>Frontend: Stitches, Radix, MobX, Responsive Design</li>
              <li>Backend: TypeORM, PostgreSQL, (Supabase, Firebase, NeonDB, MongoDB) Hasura GraphQL Engine, API Development</li>
              <li>Blockchain/3D/NFC: Smart Contracts (Solidity), ethers.js, viem, three.js</li>
              <li>Tools/Methodologies: Git, VS code CI/CD, Agile Development, JWT Authentication</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">Experience</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-bold text-gray-800 dark:text-white">Lead Full-Stack Engineer</h3>
                <p className="text-sm text-gray-600">Universe by Humans | Remote | 2023 – Present</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-white">
                  <li>Designed scalable backend systems using Nest.js and PostgreSQL.</li>
                  <li>Developed user-friendly interfaces with Next.js and integrated blockchain technologies.</li>
                  <li>Adopted GraphQL APIs via Hasura for seamless data fetching.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-800 dark:text-white">Full-Stack Developer</h3>
                <p className="text-sm text-gray-600">ARIEL Foundation International | Remote | 2021 – 2023</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-white">
                  <li>Built modular frontends with React and TypeScript.</li>
                  <li>Designed robust API architectures and implemented smart contracts.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold text-gray-800 dark:text-white">Software Engineer</h3>
                <p className="text-sm text-gray-600">StarCross Television | Calabar, Nigeria | 2019 – 2021</p>
                <ul className="list-disc list-inside text-gray-700 dark:text-white">
                  <li>Developed custom software solutions for broadcasting.</li>
                  <li>Managed frontend and backend development processes.</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">Education</h2>
            <ul className="list-disc list-inside text-gray-700 dark:text-white">
              <li>Bachelor of Computer Science - University Of Cape Coast, Ghana</li>
              <li>International Diploma in Software Engineering - Aptech India</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default OkuProfile;
